import React, { useState, useEffect } from 'react';
import store from '@Store';

const getDisplayName = (WrappedComponent) => WrappedComponent.displayName || WrappedComponent.name || 'Component';

export default function withReducer(key, reducer, injectImmediately = false) {
  // Execute if forcefully requested at definition time
  if (injectImmediately) {
    store.injectReducer(key, reducer);
  }

  return (Target) => {
    function Wrapper(props) {
      // 1. Track injection state. If the store already has the reducer, we can skip waiting.
      const [isInjected, setIsInjected] = useState(() => injectImmediately || !!store.asyncReducers[key]);

      // 2. Inject after the render phase if needed
      useEffect(() => {
        if (!isInjected) {
          store.injectReducer(key, reducer);
          setIsInjected(true);
        }
      }, [isInjected]);

      // 3. Do not render the connected component until the store has its reducer
      if (!isInjected) {
        return null;
      }

      return <Target {...props} />;
    }

    Wrapper.displayName = `withReducer("reducer:${key}", ${getDisplayName(Target)})`;
    return Wrapper;
  };
}
